import { ChipSelectOption } from './chipSelectTypes';

export const labelMarkup = (option: ChipSelectOption): string => {
  const html = option.html?.trim();
  if (!html) return option.text || '';
  const blocks = html.match(/<p[^>]*>[\s\S]*?<\/p>/gi);
  if (blocks && blocks.length > 0) {
    return blocks
      .map((block) => block.replace(/^<p[^>]*>/i, '').replace(/<\/p>$/i, ''))
      .join('<br />');
  }
  return html;
};

export const toValueList = (raw?: string | string[]): string[] => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  return raw
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);
};
